import { ValidatorFn } from "@angular/forms";
import { areIntervalsOverlapping, parse as parseFromString } from "date-fns/esm";
import { TargetHourDayValue } from "./target-hour-day-control/target-hour-day-control.component";

export const validateOverlapItems = (): ValidatorFn => {
	const now = new Date();
	const validate: ValidatorFn = (ctrl) => {
		if (!ctrl.value) return null;
		const { items }: TargetHourDayValue = ctrl.value;
		let errorCode: string;
		const hasError = items?.find((x, i, arr) => {
			const start = parseFromString(x.from, "HH:mm", now),
				end = parseFromString(x.to, "HH:mm", now);
			if (start > end) return !!(errorCode = "intervening");
			return (
				!!arr.find((y, yi) => {
					if (yi === i) return null;

					const ydata = {
						start: parseFromString(y.from, "HH:mm", now),
						end: parseFromString(y.to, "HH:mm", now),
					};
					if (!(start <= end && ydata.start <= ydata.end)) return true;
					return areIntervalsOverlapping({ start, end }, ydata);
				}) && !!(errorCode = "overlap")
			);
		});
		if (!hasError) return null;
		if (errorCode === "overlap")
			return {
				overlapped: true,
				overlapData: hasError,
			};
		if (errorCode === "intervening") {
			return {
				intervening: true,
				interveningData: hasError,
			};
		}
	};
	return validate;
};
